// Tiny shared signal for "a blocking builder overlay is open".
// Used so the global feedback FAB can tuck away while e.g. the Aggregate
// Wizard sheet is open and would otherwise overlap its controls.
let count = 0;
const listeners = new Set();

function emit() { listeners.forEach((fn) => fn(count)); }

export function pushOverlay() { count += 1; emit(); }
export function popOverlay() { count = Math.max(0, count - 1); emit(); }

export function subscribeOverlay(fn) {
  listeners.add(fn);
  fn(count);
  return () => listeners.delete(fn);
}
